<template>
  <div class="home">
    <change-tmp-password v-if="error === null">
      <v-icon slot="eye-icon" name="eye"></v-icon>
      <v-icon slot="eye-icon-closed" name="eye-off"></v-icon>
    </change-tmp-password>
    <div class="error-info" v-if="error">{{ error }}</div>
  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex';
import Auth from '@aws-amplify/auth';

export default {
  name: 'ChangePasswordView',
  methods: {},
  data(){
    return {
      error: "",
      ename: null,
    }
  },
  computed: {
    ...mapGetters(['enterprise']),
  },
  mounted() {
    if ((this.enterprise === null) || (this.$route.query.enterprise !== undefined)) {
      this.ename = this.$route.query.enterprise;
      const client = window.btoa(this.ename);
      axios.get(`${this.$store.getters.url}client/${client}`).then((res) => {
        if (res.data.Items.length > 0) {
          this.error = null;
          let enterprise = res.data.Items[0];
          enterprise.id64 = client;
          this.$store.dispatch('setEnterprise', enterprise);
          const awsExports = {
            aws_project_region: enterprise.poolInfo.region,
            aws_cognito_region: enterprise.poolInfo.region,
            aws_user_pools_id: enterprise.poolInfo.userPoolId,
            aws_user_pools_web_client_id: enterprise.poolInfo.clientId,
          };
          Auth.configure(awsExports);
        } else {
          this.error = "L'entreprise choisi n'existe pas, contactez le support";
        }
      }).catch(() => {
        this.error = this.error = "L'entreprise choisie n'existe pas, contactez le support";
      });
    }
  }
};
</script>
<style scoped>
 .error-info {
        text-align: center;
        color: red;
        border: 1px solid red;
        padding: 40px;
        margin: 2px;
        font-size: 12px;
    }
</style>